// extracted by mini-css-extract-plugin
export var center = "style-module--center--fb11b";
export var contents = "style-module--contents--8e9d6";
export var date = "style-module--date--99255";
export var header = "style-module--header--87ef7";
export var headerContainer = "style-module--headerContainer--8ad0d";
export var history = "style-module--history--920d9";
export var label = "style-module--label--93558";
export var languageSwitch = "style-module--languageSwitch--740f5";
export var left = "style-module--left--9d594";
export var loading = "style-module--loading--ee928";
export var logoContainer = "style-module--logoContainer--60d8e";
export var menuSwitch = "style-module--menuSwitch--a6c85";
export var mypage = "style-module--mypage--b1344";
export var popupContainer = "style-module--popupContainer--a2e04";
export var right = "style-module--right--bed30";
export var save = "style-module--save--0ca16";
export var signup = "style-module--signup--e2c38";
export var signupButton = "style-module--signupButton--58cd4";